import React from 'react';

const Star = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    {...props}
  >
    <path d="M14.4078 4.15153C14.9755 2.31929 17.5471 2.25961 18.1991 4.06355L20.3811 10.0999H26.4886C28.2971 10.0999 29.1769 12.3094 27.8634 13.5525L23.2418 17.9265L24.9101 24.7281C25.3529 26.5334 23.3086 27.9136 21.7997 26.828L16.2453 22.8319L10.6909 26.828C9.18201 27.9136 7.13762 26.5334 7.58044 24.7281L9.24322 17.9491L4.3185 13.5989C2.9379 12.3794 3.80047 10.0999 5.64257 10.0999H12.5648L14.4078 4.15153ZM18.5002 10.7798L16.3182 4.74343L14.4752 10.6919C14.2158 11.5292 13.4414 12.0999 12.5648 12.0999L5.64257 12.0999L10.5673 16.4501C11.1246 16.9424 11.3628 17.7033 11.1856 18.4255L9.52286 25.2045L15.0773 21.2084C15.775 20.7064 16.7155 20.7064 17.4133 21.2084L22.9677 25.2045L21.2994 18.403C21.1281 17.7047 21.3448 16.9682 21.867 16.4739L26.4886 12.0999H20.3811C19.5387 12.0999 18.7866 11.5721 18.5002 10.7798Z" />
  </svg>
);

export default Star;
